var map = {
	"./alert-circle-outline.svg": "e14e",
	"./alert-triangle-outline.svg": "c993",
	"./arrow-circle-down-outline.svg": "d53e",
	"./arrow-downward-outline.svg": "191b",
	"./arrow-ios-back-outline.svg": "31a5",
	"./arrow-ios-forward-outline.svg": "1351",
	"./arrow-right.svg": "7f3d",
	"./atm-outline.svg": "a6e3",
	"./bank-outline.svg": "601d",
	"./banknotes-outline.svg": "e5fe",
	"./briefcase-outline.svg": "f106",
	"./briefcase.svg": "5a38",
	"./card-outline.svg": "6fb6",
	"./chat.svg": "6e1a",
	"./checkmark-circle-2-outline.svg": "e380",
	"./checkmark-circle-2.svg": "defa",
	"./checkmark-outline.svg": "0df1",
	"./clock.svg": "c4af",
	"./close-circle.svg": "4d41",
	"./close-outline.svg": "23e9",
	"./courier-outline.svg": "d4b0",
	"./email-outline.svg": "c7db",
	"./file-text-outline.svg": "0d90",
	"./globe-2-outline.svg": "b638",
	"./home-outline.svg": "d661",
	"./home.svg": "1c14",
	"./image-outline.svg": "2e33",
	"./info-outline.svg": "d170",
	"./iute-pepper-outline.svg": "8aa3",
	"./log-in-outline.svg": "f90f",
	"./log-in.svg": "c837",
	"./log-out.svg": "fecf",
	"./message-square-outline.svg": "b0a6",
	"./money-outline.svg": "b07e",
	"./phone-call-outline.svg": "beb0",
	"./phone-call.svg": "5b66",
	"./pin-outline.svg": "6535",
	"./pin.svg": "e762",
	"./plus-outline.svg": "7b80",
	"./qr-code.svg": "c8c6",
	"./refresh.svg": "b3cd",
	"./settings-2-outline.svg": "10af",
	"./social-facebook.svg": "ef65",
	"./social-instagram.svg": "5040",
	"./social-linkedin.svg": "1599",
	"./social-messenger.svg": "a7ed",
	"./social-viber.svg": "1042",
	"./social-whatsapp.svg": "c2b7",
	"./social-youtube.svg": "7db1",
	"./square-outline.svg": "1cfb",
	"./star-outline.svg": "6ea3",
	"./user-circle-outline.svg": "d926",
	"./wallet-outline.svg": "f123"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "df94";